module.exports = __webpack_public_path__ + "a826e96e447dbe88f89b20051050e912.svg";